import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * サインアウトハンドラを返すカスタムフック。
 * /medichat/logout ページに遷移し、LogoutPage 側でバックエンドへの
 * ログアウトリクエスト送信と patientWebSession のクリアを行う。
 */
export const useSignOut = () => {
  const navigate = useNavigate();
  return useCallback(() => {
    navigate('/medichat/logout');
  }, [navigate]);
};
